<template>
  <div>
  <div v-if="deviceValue !==3">
    <div class="handle-box">
      <el-cascader :props="props"
                   v-model="area_store"
                   placeholder="选择或搜索门店"
                   @visible-change="visibleChange"
                   @change="clearRoom"
                   collapse-tags
                   clearable
                   filterable></el-cascader>
      <el-select v-model="query.room_id" clearable placeholder="房间" class="handle-select mr5">
        <el-option
            v-for="item in searchRooms"
            :key="item.value"
            :label="item.label"
            :value="Number(item.value)"
        ></el-option>
      </el-select>
      <el-select v-model="query.from" clearable placeholder="来源" class="handle-select mr5">
        <el-option
            v-for="item in fromOptions"
            :key="item.value"
            :label="item.label"
            :value="Number(item.value)"></el-option>
      </el-select>
      <el-input v-model="query.name" placeholder="设备名" class="handle-input mr5"></el-input>
      <el-input v-model="query.code" placeholder="设备编码" class="handle-input mr5"></el-input>
      <el-select v-model="query.is_validate" clearable placeholder="有效" class="mr5" style="width: 100px;">
        <el-option key="1" label="是" value="1"></el-option>
        <el-option key="2" label="否" value="0"></el-option>
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="addDevice">添加</el-button>
    </div>
    <el-table
        :data="tableData"
        border
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header"
        :cell-style="centerStyle"
    >
      <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
      <el-table-column prop="name" label="设备名" width="200" show-overflow-tooltip header-align="center"></el-table-column>
      <el-table-column prop="code" label="编码" header-align="center" width="250">
        <template #default="scope" >
          <el-button type="text" :style="'color:#409EFF'"
                     @click="showDetail(scope.row.id)">
            {{scope.row.code}}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="control" label="控制位" width="75"></el-table-column>
      <el-table-column prop="store_name" label="门店" ></el-table-column>
      <el-table-column prop="room_name" label="房间"  header-align="center"></el-table-column>
      <el-table-column prop="delay" label="延时"  header-align="center" v-if="(deviceValue===1) || (deviceValue===2)"></el-table-column>
      <el-table-column prop="type" label="类型" align="center" width="120">
        <template #default="scope">
          <span>{{ typeMap.get(scope.row.type) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否有效" width="100" align="center">
        <template #default="scope">
          <el-button type="text" :style="'color:'+[!scope.row.is_validate?'red':'']"
                     @click="setIsvalidate(scope.$index, scope.row.id, !scope.row.is_validate)">
            {{ scope.row.is_validate ? "有效" : "无效" }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280" align="center">
        <template #default="scope">
          <el-button
              type="text"
              icon="el-icon-edit"
              @click="setControl(scope.row)"
              v-if="deviceAllow"
          >控制
          </el-button>
          <el-button
              type="text"
              icon="el-icon-edit"
              @click="editDevice(scope.row)"
          >编辑
          </el-button>
          <el-button
              type="text"
              icon="el-icon-delete"
              class="red"
              @click="handleDelete(scope.row.id)"
          >删除
          </el-button>
        </template>

      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="query.page"
          :page-size="query.page_size"
          :total="pageTotal"
          @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </div>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick" v-else>
  <el-tab-pane label="基本信息" name="local-basic">
      <div class="handle-box">
        <el-select v-model="query.store_id" clearable placeholder="门店" class="handle-select mr5">
          <el-option
              v-for="item in storeOptions"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
              @click="getRoomOption(item.value)"
          ></el-option>
        </el-select>
        <el-select v-model="query.room_id" clearable placeholder="房间" class="handle-select mr5">
          <el-option
              v-for="item in searchRooms"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
          ></el-option>
        </el-select>
        <el-select v-model="query.from" clearable placeholder="来源" class="handle-select mr5 ">
          <el-option
              v-for="item in fromOptions"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"></el-option>
        </el-select>
        <el-input v-model="query.name" placeholder="设备名" class="handle-input mr5"></el-input>
        <el-input v-model="query.code" placeholder="设备编码" class="handle-input mr5"></el-input>
        <el-select v-model="query.is_validate" clearable placeholder="有效" class="mr5" style="width: 100px;">
          <el-option key="1" label="是" value="1"></el-option>
          <el-option key="2" label="否" value="0"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="addDevice">添加</el-button>
      </div>
      <el-table
          :data="tableData"
          border
          class="table"
          ref="multipleTable"
          header-cell-class-name="table-header"
          :cell-style="centerStyle"
      >
        <el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>
        <el-table-column prop="name" label="设备名" width="200" show-overflow-tooltip header-align="center"></el-table-column>
        <el-table-column prop="code" label="编码" header-align="center" width="200">
          <template #default="scope" >
            <el-button type="text" :style="'color:#409EFF'"
                       @click="showDetail(scope.row.id)">
              {{scope.row.code}}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="control" label="控制位" width="75"></el-table-column>
        <el-table-column prop="store_name" label="门店" ></el-table-column>
        <el-table-column prop="room_name" label="房间"  header-align="center"></el-table-column>
        <el-table-column prop="delay" label="延时"  header-align="center" v-if="(deviceValue===1) || (deviceValue===2)"></el-table-column>
        <el-table-column prop="type" label="类型" align="center" width="120">
          <template #default="scope">
            <span>{{ typeMap.get(scope.row.type) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否有效" width="100" align="center">
          <template #default="scope">
            <el-button type="text" :style="'color:'+[!scope.row.is_validate?'red':'']"
                       @click="setIsvalidate(scope.$index, scope.row.id, !scope.row.is_validate)">
              {{ scope.row.is_validate ? "有效" : "无效" }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="280" align="center">
          <template #default="scope">
            <el-button
                type="text"
                @click="setControl(scope.row)"
                v-if="deviceAllow"
            >控制
            </el-button>
            <el-button
                type="text"
                icon="el-icon-edit"
                @click="editDevice(scope.row)"
            >编辑
            </el-button>
            <el-button
                type="text"
                icon="el-icon-delete"
                class="red"
                @click="handleDelete(scope.row.id)"
            >删除
            </el-button>
          </template>

        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="query.page"
            :page-size="query.page_size"
            :total="pageTotal"
            @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </el-tab-pane>
    <el-tab-pane label="实时信息" name="local-real">
      <el-table
          :data="realList"
          border
          class="table"
          ref="multipleTable"
          header-cell-class-name="table-header"
          :cell-style="centerStyle"
      >
        <el-table-column prop="kt_mac" label="设备编码" width="170" align="center"></el-table-column>
        <el-table-column prop="kt_wkqid" label="控制位" width="100" align="center"></el-table-column>
        <el-table-column prop="kt_txzt" label="状态" align="center">
          <template #default="scope">
            <span>{{ scope.row.kt_txzt === (88 || 66)?'在线':'离线'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="kt_txzt" label="开机状态" align="center">
          <template #default="scope">
            <span>{{ scope.row.kt_kgzt === 0?'关机':'开机'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="kt_mode" label="模式" align="center">
          <template #default="scope">
            <span>{{ modeMap.get(scope.row.kt_mode) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="kt_setwd" label="设置温度" align="center">
          <template #default="scope">
            <span>{{ scope.row.kt_setwd }} ℃</span>
          </template>
        </el-table-column>
        <el-table-column prop="kt_sswd" label="实时温度" align="center">
          <template #default="scope">
            <span>{{ scope.row.kt_sswd }} ℃</span>
          </template>
        </el-table-column>
        <el-table-column prop="kt_fengsuset" label="设置风速" align="center">
          <template #default="scope">
            <span>{{ fengsuMap.get(scope.row.kt_fengsuset) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="kt_fengsu" label="实时风速" align="center">
          <template #default="scope">
            <span>{{scope.row.kt_fengsu === 0 ? '关机' :  fengsuMap.get(scope.row.kt_fengsu) }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="kt_lock" label="温控器锁定状态" align="center" width="170">
          <template #default="scope">
            <span>{{ scope.row.kt_lock === 0?'未锁定':'锁定'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="kt_sfzt" label="水阀状态" align="center">
          <template #default="scope">
            <span>{{ scope.row.kt_sfzt === 0?'关':'开'}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="realquery.page"
            :page-size="realquery.page_size"
            :total="realPageTotal"
            @current-change="realPageChange"
        ></el-pagination>
      </div>
    </el-tab-pane>
  </el-tabs>

  <!-- 编辑弹出框 -->

  <el-dialog
      v-model="editVisible"
      :title="[form.code ?'编辑':'添加']+'设备'"
      @close="editVisible = false"
      :width="550"
  >
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="100px">
      <el-form-item prop="name" label="名称：">
        <el-input v-model="form.name" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item prop="code" label="编码：">
        <el-input v-model="form.code" placeholder="请输入编码"></el-input>
      </el-form-item>
      <el-form-item label="控制位：">
        <el-input-number v-model="form.control" :controls="false"></el-input-number>
      </el-form-item>
      <el-form-item label="延时：" v-if="(deviceValue===1) || (deviceValue===2)">
        <el-input-number v-model="form.delay" :controls="false" min="-1800" max="1800"></el-input-number><span class="tip"> (单位：秒，-1为不自动执行)</span>
      </el-form-item>

      <el-form-item prop="store_id" label="门店：" class="w350">
        <el-select
            v-model.number="form.store_id"
            clearable
            @clear="clearRoom"
        >
          <el-option
              v-for="item in allStoreOptions"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"
              @click="getRoomOption(item.value)">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="room_id" label="房间：" class="w350">
        <el-select
            v-model="form.room_id"
            clearable>
          <el-option
              v-for="item in roomOptions"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="控制类型："  class="w250"  v-if="deviceValue == 1">
        <el-select
            v-model="form.control_type"
            clearable>
          <el-option
              v-for="item in control_type"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备来源：" class="w250" prop="from">
        <el-select
            v-model="form.from"
            clearable>
          <el-option
              v-for="item in fromOptions"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="设备类型："  class="w250">
        <el-select
            v-model="form.type"
            disabled
            clearable>
          <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="Number(item.value)"></el-option>
        </el-select>
      </el-form-item>
      <div style="text-align: right; margin-top: 10px">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" @click="saveEdit">保存</el-button>
      </div>
    </el-form>
  </el-dialog>
  <el-dialog
      v-model="commandVisible"
      :title="[form.code ?'编辑':'添加']+'命令'"
      @close="commandVisible = false">
    <el-form
        ref="form"
        :model="command"
        :rules="commandRules"
        label-width="100px">
      <el-form-item prop="name" label="名称：">
        <el-input v-model="command.name" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item prop="value" label="指令：">
        <el-input :autosize="{minRows: 5}" type="textarea" v-model.json="command.value" placeholder="请输入指令"></el-input>
      </el-form-item>
      <el-form-item prop="is_validate" label="是否有效：">
        <el-switch v-model="form.is_validate"></el-switch>
      </el-form-item>
      <div style="text-align: right; margin-top: 10px">
        <el-button @click="commandVisible = false">取消</el-button>
        <el-button type="primary" @click="addCommandSubmit">保存</el-button>
      </div>
    </el-form>

  </el-dialog>
  <el-dialog  width="20%" title="控制" v-model="controlVisible">
    <div class="box">
      <el-form  :model="controlData" label-width="80px">
        <el-form-item label="控制位:" v-if="deviceContorl">
          <el-input placeholder="请输入控制位" v-model="controlData.value"></el-input>
        </el-form-item>
        <el-form-item v-else label="开关：">
          <el-switch
              v-model="controlData.value"
              active-color="#13ce66"
              inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <div style="text-align: right; margin-top: 10px">
          <el-button @click="controlVisible = false">取消</el-button>
          <el-button type="primary" @click="controlEdit">发送</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
  <el-dialog
      title="设备详情"
      v-model="detailVisible"
      width="30%"
  >
    <div class="rowstyle">
      <el-row :gutter="16">
        <el-col :span="6"><div class="grid-content bg-purple">设备名</div></el-col>
        <el-col :span="10"><div class="grid-content bg-purple">{{detailData.name}}</div></el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6"><div class="grid-content bg-purple">设备编码</div></el-col>
        <el-col :span="10"><div class="grid-content bg-purple">{{detailData.code}}</div></el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6"><div class="grid-content bg-purple">控制位</div></el-col>
        <el-col :span="10"><div class="grid-content bg-purple">{{ detailData.control}}</div></el-col>
      </el-row>
      <el-row :gutter="16"  v-if="(deviceValue===1) || (deviceValue===2)">
        <el-col :span="6"><div class="grid-content bg-purple">延时</div></el-col>
        <el-col :span="10"><div class="grid-content bg-purple">{{ detailData.delay}}</div></el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6"><div class="grid-content bg-purple">门店</div></el-col>
        <el-col :span="10"><div class="grid-content bg-purple">{{ detailData.store_name}}</div></el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6"><div class="grid-content bg-purple">房间</div></el-col>
        <el-col :span="10"><div class="grid-content bg-purple">{{ detailData.room_name}}</div></el-col>
      </el-row>
      <el-row :gutter="16" v-if="deviceValue == 1">
        <el-col :span="6"><div class="grid-content bg-purple">控制类型</div></el-col>
        <el-col :span="10"><div class="grid-content bg-purple">{{ detailData.control_type==0?'科技侠':'微耕'}}</div></el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6"><div class="grid-content bg-purple">设备类型</div></el-col>
        <el-col :span="10"><div class="grid-content bg-purple">{{ typeMap.get(detailData.type)}}</div></el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6"><div class="grid-content bg-purple">设备来源</div></el-col>
        <el-col :span="10"><div class="grid-content bg-purple">{{ fromMap.get(detailData.from)}}</div></el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6"><div class="grid-content bg-purple">是否有效</div></el-col>
        <el-col :span="10"><div class="grid-content bg-purple">{{ detailData.is_validate ? '有效' : '无效'}}</div></el-col>
      </el-row>
      <el-row :gutter="16">
        <el-col :span="6"><div class="grid-content bg-purple">添加时间</div></el-col>
        <el-col :span="10"><div class="grid-content bg-purple">{{ForMatHMS(detailData.c_at)}}</div></el-col>
      </el-row>
    </div>
    </el-dialog>
  <el-dialog
      title="空调控制"
      v-model="airVisible"
      width="50%"
  >
    <div class="box box2" v-if="deviceValue == 3">
      <el-form  :model="airForm.value" label-width="120px">
        <div class="box3">
          <el-form-item label="配置类型：">
            <el-select
                class="el-select"
                v-model="airForm.value.set_type">
              <el-option
                  v-for="item in config_type"
                  :key="item.value"
                  :label="item.label"
                  :value="Number(item.value)"
                  @click="setVal"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="airForm.value.set_type == 1" class="el-form-item" prop="set_val">
            <el-input  v-model="airForm.value.set_val" oninput = "value=value.replace(/[^\d.]/g,'')" @blur="changes"></el-input> ℃
          </el-form-item>
          <el-form-item v-else class="el-form-item">
            <el-radio-group v-model="airForm.value.set_val">
              <el-radio :label="item.value" v-for="item in setList" :key="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div style="text-align: right;" class="footer">
          <el-button @click="airVisible = false">取消</el-button>
          <el-button type="primary" @click="configEdit">发送</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</div>
</template>

<script>
import moment from "moment";

import {
  controlDevice,
  deleteDevice,
  getDeviceList,
  getDeviceType,
  saveTYDevice,
  setDeviceIsvalidate,
  getAirList
} from "@/api/device";
import {getAreaOption, getStoreOption} from "@/api/store";
import {getRoomOption} from "@/api/room";
import {addCommand} from "@/api/command";
import {config_type} from "@/constant/config_type";
import {control_type} from "@/constant/control_type"
import {set_val} from "@/constant/setval";
export default {
  name: "DeviceType",
  components:{},
  props:{
    deviceType:{
      type: String,
      required: true,
    },
    deviceValue:{
      type: Number,
      required: true,
    },
    deviceAllow:{
      type: Boolean,
      required: true,
    },
    deviceContorl:{
      type: Boolean,
      required: true,
    },
    deviceFrom:{
      type:Object,
      required: true
    }
  },
  data() {
    return {
      controlVisible:false,
      switchValue:false,
      query: {
        name: "",
        code: "",
        from: null,
        is_validate: null,
        page: 1,
        page_size: 10
      },
      tableData: [],
      storeOptions: [],
      roomOptions:[],
      searchRooms:[],
      fromOptions:[],
      typeOptions:[],
      pageTotal:0,
      form: {
        id: 0,
        name: '',
        code: '',
        control: 0,
        is_validate: true,
        room_id: 0,
        delay:0,
        control_type:0
      },
      command: {
        id: null,
        device_id: null,
        name: null,
        value: null,
      },
      rules: {
        name: [{required: true, message: '请输入名称', trigger: 'blur'}],
        code: [{required: true, message: '请输入编码', trigger: 'blur'}],
        store_id: [{required: true, message: '请选择门店', trigger: 'change'}],
        from: [{required: true, message: '请选择设备来源', trigger: 'change'}]
      },
      commandRules: {
        name: [{required: true, message: '请输入名称', trigger: 'blur'}],
        value: [{required: true, message: '请输入指令', trigger: 'blur'}],
      },
      airRules:{
        set_val:[
            {max:30,min:15,message: '最高温度30，最低温度15', trigger: 'change'},
            {type:'number',message: '只能输入数字', trigger: 'change'}
        ]
      },
      actTitle:"新增", // 弹框标题
      editVisible:false, // 弹框开启状态
      commandVisible:false,
      fromMap: new Map(),
      typeMap: new Map(),
      allData:[],
      pageNewTotal:null,
      controlData:{
        value:false,
        id:0,
      },
      detailVisible:false,
      detailData:{},
      airVisible:false,
      airForm:{
        value:{
          set_type:null,
          set_val:null,
        },
        id:1
      },
      setList:[],
      activeName:'local-basic',
      realList:[],
      realquery:{
        page:1,
        page_size: 10
      },
      realPageTotal:0,
      modeMap:new Map(),
      fengsuMap:new Map(),
      areaOptions:[],
      area_store:[],
      props: {},
      allStoreOptions:[]
    };
  },
  computed:{
    config_type(){
      return config_type
    },
    control_type(){
      return control_type
    }
  },
  mounted() {
    this.getCompant()
  },
  methods: {
    init(){
      this.getAreaOptions()
      this.getStoreOption()
      this.getData();
      this.getDeviceFromOption();
      this.getDeviceTypeOption();
      this.getRealAir()
      this.getAllStoreOption()
    },
    getCompant(){
      this.props = {
        // checkStrictly: true,
        lazy: true,
        lazyLoad:this.lazyLoad
      }
    },
    getAllStoreOption() {
      this.allStoreOptions = [{value: 0, label: '平台'}]
      getStoreOption().then(res => {
        res.forEach(function (val) {
          this.allStoreOptions.push({label: val.label, value: parseInt(val.value)})
        }, this)
      })
    },

    centerStyle(){
      return 'text-align:center'
    },

    ForMatHMS(date) {
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },

    clearRoom() {
      this.query.room_id = null
      this.form.room_id = null
      this.roomOptions = []
      this.searchRooms = []
    },

    dateFormat: function (row, column) {
      const date = row[column.property];
      if (date === undefined) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD")
    },

    lazyLoad(node, resolve) {
      const { level } = node;
      if(level === 0){
        this.getAreaOptions()
        let nodes = []
        if(this.areaOptions !== []){
          setTimeout(() => {
            nodes = this.areaOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level === 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }
      if(level === 1){
        let nodes = []
        this.getStoreOption(node.value)
        if(this.storeOptions !== []){
          setTimeout(() => {
            nodes = this.storeOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level === 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }
    },
    visibleChange(val){
      setTimeout(()=>{
        if(!val && this.area_store != null && this.area_store.length>1){
          this.query.store_id = this.area_store[1]
          this.getRoomOption(this.query.store_id)
        }
      },200)

    },
    // 获取地址列表
    getAreaOptions(){
      getAreaOption().then(res=>{
        this.areaOptions = res
      })
    },

    getData() {
      this.query.area_id = this.area_store!== null ? this.area_store[0] : null
      this.query.store_id = (this.area_store!== null && this.area_store.length>1) ? this.area_store[1] : null
      this.tableData=[]
      this.query.type = this.deviceValue
      getDeviceList(this.query).then(res => {
        this.tableData = res.data
          this.pageTotal = res.count
      })
    },

    // 触发搜索按钮
    handleSearch() {
      this.query.page = 1
      this.getData()
    },

    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },

    // 添加弹框
    addDevice() {
      this.form = {}
      this.form.id = 0
      this.form.store_id = 0
      this.form.room_id = null
      this.form.type = this.deviceValue
      this.editVisible = true
      this.getRoomOption(this.form.store_id)
    },

    saveEdit() {
      this.form.delay = Number(this.form.delay)
      this.$refs.form.validate(valid => {
        if (!valid) return
        saveTYDevice(this.form).then(() => {
          this.$message.success('保存成功')
          this.editVisible = false
          this.getData()
        })
      })
    },

    // 编辑弹框
    editDevice(row) {
      this.actTitle = "编辑"
      this.form = JSON.parse(JSON.stringify(row))
      this.form.code = row.code
      this.form.name = row.name
      this.form.control = row.control || 0
      this.form.is_validate = row.is_validate
      this.form.room_id = row.room_id || 0
      this.form.store_id = row.store_id || 0
      this.form.from = row.from
      this.form.type = this.deviceValue || 0
      this.form.id = row.id
      this.editVisible = true
      this.getRoomOption(this.form.store_id)
    },

    // 删除操作
    handleDelete(id) {
      // 二次确认删除
      this.$confirm("确定要删除吗？", "删除提示", {
        type: "warning"
      }).then(() => {
        deleteDevice(id).then(res => {
          if (res) {
            this.$message.success('删除成功')
          }
          this.getData()
        })
      })
    },

    setIsvalidate(index, id, isvalidate) {
      setDeviceIsvalidate(id, isvalidate).then(res => {
        if (res === true) {
          this.$message.success('保存成功')
          this.tableData[index].is_validate = isvalidate
        }
      })
    },

    //获取门店信息
    getStoreOption(id) {
      this.storeOptions = []
      getStoreOption(id).then(res => {
        res.forEach(function (val) {
          this.storeOptions.push({label: val.label, value: parseInt(val.value)})
        }, this)
      })
    },


    // 获取房间信息
    getRoomOption(id) {
      this.query.room_id = null
      getRoomOption(id).then(res => {
        this.roomOptions = [{value:0,label:'无'}]
        this.searchRooms = []
        let that = this
        res.forEach(function (item) {
          that.roomOptions.push(item)
          if(id === that.query.store_id){
            that.searchRooms = JSON.parse(JSON.stringify(that.roomOptions))
          }
        })
      })
    },


    getDeviceFromOption() {
      // getDeviceFrom().then(res => {
      //   let that = this
      //   res.forEach(function (item) {
      //     that.fromMap.set(item.value, item.label)
      //   })
      //   this.fromOptions = res
      // })
      this.fromOptions = this.deviceFrom
      console.log(this.deviceFrom)
    },

    getDeviceTypeOption() {
      getDeviceType().then(res => {
        let that = this
        res.forEach(function (item) {
          that.typeMap.set(item.value, item.label)
        })
        this.typeOptions = res
      })
    },


    editAddCommand(row) {
      this.command = {}
      this.command.device_id = row.id
      this.commandVisible = true
    },

    addCommandSubmit() {
      addCommand(this.command).then(res=>{
        if (res === true) {
          this.$message.success('添加成功')
          this.commandVisible = false
        }
      })
    },

    // 打开子组件
    showProduct(row) {
      this.productVisible = true
      setTimeout(()=>{
        this.$refs["product"].showProducts(row.id)
      },100)
    },

    //设置控制
    setControl(row){
      this.controlData.id= row.id
      this.airForm.id = row.id
      if(this.deviceValue == 3){
        this.airControl()
      }else {
        this.controlVisible = true
      }
    },

    //   保存控制
    controlEdit(){
      this.controlVisible = false
      controlDevice(this.controlData).then(res=>{
        if (res === true) {
          this.$message.success('运行成功')
        }else {
          this.$message.success(res)
        }
        this.getData()
      })
    },

  //设备详情
    showDetail(id){
      this.tableData.forEach(item => {
        this.fromMap.set(item.value, item.label)
        if(item.id === id){
          this.detailData = JSON.parse(JSON.stringify(item))
        }
      })
      this.detailVisible = true
    },

    airControl(){
      this.airVisible = true
    },
    setVal(){
        for(let key in set_val) {
          if (key == this.airForm.value.set_type && key !== 1) {
            this.setList = set_val[key]
          }
        }
    },
    configEdit(){
      this.airVisible = false
      this.airForm.value.set_val = Number(this.airForm.value.set_val)
      let data = JSON.parse(JSON.stringify(this.airForm))
      data.value = JSON.stringify(data.value)
      controlDevice(data).then(res=>{
        if (res === true) {
          this.$message.success('运行成功')
          this.getData()
        }
      })
    },

    changes(){
       if (this.airForm.value.set_val < 15) {
            this.airForm.value.set_val = 15;
       }
       if (this.airForm.value.set_val > 30) {
            this.airForm.value.set_val = 30;
      }
    },
    getRealAir(){
      getAirList(this.realquery).then(res=>{
        let that = this
        this.realList = res.roomssdata
        this.realPageTotal = res.records
        set_val[3].forEach(function (item){
          that.modeMap.set(item.value, item.label)
        })
        set_val[5].forEach(function (item){
          that.fengsuMap.set(item.value, item.label)
        })
      })
    },
    realPageChange(val){
        this.realquery.page = val
        this.getRealAir()
    }
  },
};
</script>
<style scoped>
.handle-box {
  margin-bottom: 10px;
}

.mr10 {
  margin-right: 10px;
}
.el-input,.el-select {
  width: 200px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.el-dialog__body .el-select,.el-dialog__body .el-input {
  width: 80%;
}

.red {
  color: red;
}

.box{
  margin: 0 auto;
}

.box .el-input{
  width: 60%;
}

.rowstyle{
  width: 100%;
  margin: 0 auto;
  padding-left: 15%;
}

.el-row {
  margin-bottom: 10px;
}
.el-col {
  border-radius: 4px;

}

.row-bg {
  padding: 5px 0;
  background-color: #f9fafc;
}
.grid-content {
  border-radius: 4px;
  min-height: 24px;
  text-align: center;
  line-height: 24px;
}

.tip{
  font-size: 12px;
  color: red;
}

.box2 .el-form-item{
  float: left;
  text-align: left;
}
.box3{
  width: 100%;
  height: 100px;
}
.footer{
  width: 100%;
}

.box2 .el-form-item:nth-child(2) /deep/.el-form-item__content{
  margin-left: 10px !important;
}
.w350{
  width: 350px;
}
.w250{
  width: 250px;
}
</style>